import axios from 'axios';
import { constructServiceURL } from '../../../../../../utils/URLTools';

export const apiEditMrd = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getMrdListDefault',
    stub: process.env.useStubbedEndpoints,
  });
  return axios.put(serviceURL, payload);
};
